// =====================================
// src/services/quoteActions.js
// Aceptar y solicitar cambios - 'accept' envía JSON completo para evitar 400
// =====================================
import api from './api';

/** Aprueba una cotización */
export async function acceptQuote(quoteNumber, token) {
  const params = token ? { token } : undefined;

  // Enviamos un payload "amigable" para backends que validan el body
  const payload = {
    quoteNumber,                 // nombre usado en el frontend
    number: quoteNumber,         // alias común
    action: 'accept',            // operación
    source: 'pdf',               // desde dónde se originó
  };

  const res = await api.post(
    `/quotes/${encodeURIComponent(quoteNumber)}/accept`,
    payload,
    {
      params,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    }
  );
  return res.data || {};
}

/** Envía solicitud de cambios */
export async function submitChangeRequest(quoteNumber, message, token, contact) {
  const params = token ? { token } : undefined;
  const body = { message, contact, quoteNumber, action: 'modify', source: 'pdf' };
  const res = await api.post(`/quotes/${encodeURIComponent(quoteNumber)}/modify`, body, { params });
  return res.data || {};
}
